module.exports = __webpack_public_path__ + "9270c5b1d2756ba7a3570a510027fc4a.patt";